import i18n from '../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import './PopupOffline.css';

const PopupOffline = () => {
  return <div className="popup_offline"> 
    <div className="popup_content">
      <div className="icon"><ReactSVG src="assets/images/logo_white.svg" /></div>
      <h2>{i18n.t('noInternetConnection')}</h2>
      <p>{i18n.t('noInternetConnectionText')}</p>
    </div>
  </div>;
};

export default PopupOffline;